import * as React from 'react';
const columnIdContext = React.createContext(undefined);
export const columnIdContextDefaultValue = '';
export const useColumnIdContext = () => {
  var _React_useContext;
  return (_React_useContext = React.useContext(columnIdContext)) !== null && _React_useContext !== void 0 ? _React_useContext : columnIdContextDefaultValue;
};
export const ColumnIdContextProvider = columnIdContext.Provider;